/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Leadership_Founder_BioInputs */

const en_landing_leadership_founder_bio = /** @type {(inputs: Landing_Leadership_Founder_BioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark founded Inginuiti to fix the problem of high-conviction research being buried in inboxes and trading commissions being lost, drawing on c.20 years in finance including Equity Research at Bernstein and Jefferies, in Energy teams ranked Top-3 by Institutional Investor and Extel.`)
};

/**
* | output |
* | --- |
* | "Mark founded Inginuiti to fix the problem of high-conviction research being buried in inboxes and trading commissions being lost, drawing on c.20 years in fi..." |
*
* @param {Landing_Leadership_Founder_BioInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_leadership_founder_bio = /** @type {((inputs?: Landing_Leadership_Founder_BioInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Leadership_Founder_BioInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_leadership_founder_bio(inputs)
});